import { STATUS_MODEL } from '../../../../../enums/statusEnum';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
import {
    DAYS_MODEL,
    DEFAULT_LATITUDE,
    DEFAULT_LONGITUDE,
    getTimeFormatFromTime,
    getToTime,
} from '../../../../../Apis/functions';
import { colors } from '../../../../../enums/colors';
import L from 'leaflet';

// Used to switch between the different subviews in the Manage section
export const MANAGE_VIEW_TYPE = {
    FINES: 0,
    GEOFENCES: 1,
};

export const MEDIA_OPTIONS = {
    EMAIL: 2,
    APP_NOTIFICATION: 5,
    SMS_MESSAGE: 3,
};

export const FINES_MODEL = {
    id: null,
    warningsCount: null,
    firstTimeFineAmount: null,
    standardFineAmount: null,
    recurrencePenaltyType: null,
    recurrencePenaltyValue: null,
    recurrenceCooldownValue: null,
    recurrenceCooldownUnit: null,
    maxDiscountPeriod: null,
    maxDiscountUnit: null,
    earlyPaymentDiscountType: null,
    earlyPaymentDiscountValue: null,
    suspensionGracePeriod: null,
    suspensionGraceUnit: null,
    finesBeforeRecurrence: null,
    mediaOptions: [
        {
            mediaOptionId: MEDIA_OPTIONS.APP_NOTIFICATION,
            statusId: STATUS_MODEL.IN_ACTIVE_COMPANY, //is initialized as inactive
        },
        {
            mediaOptionId: MEDIA_OPTIONS.SMS_MESSAGE,
            statusId: STATUS_MODEL.IN_ACTIVE_COMPANY,
        },
        {
            mediaOptionId: MEDIA_OPTIONS.EMAIL,
            statusId: STATUS_MODEL.IN_ACTIVE_COMPANY,
        },
    ],

    isValid() {
        // Convert model properties to entries
        const entries = Object.entries(this);

        for (const [key, value] of entries) {
            // Skip methods
            if (typeof value === 'function') continue;

            // Validate array of objects (mediaOptions)
            if (Array.isArray(value)) {
                if (value.length === 0) return false;

                const allValid = value.every(
                    (item) => item && Object.values(item).every((v) => v !== null && v !== undefined && v !== ''),
                );

                if (!allValid) return false;
                continue;
            }

            // Validate primitives
            if (value === null || value === undefined || value === '') {
                return false;
            }
        }

        return true;
    },
};

export const TIME_UNITS = [
    { id: 'DAYS', name: 'days' },
    { id: 'WEEKS', name: 'weeks' },
    { id: 'MONTHS', name: 'months_label' },
];
export const UNIT_TYPE = [
    { id: 'PERCENTAGE', name: 'percentage' },
    { id: 'AMOUNT', name: 'amount' },
];

// Geofence model with default values and utility functions.
export const GEOFENCES_MODEL = {
    geofenceId: null,
    geofenceConfigId: null,
    name: '',
    speedUnit: null,
    speedLimit: null,
    speedTolerance: null,
    description: '',
    applyEmployee: false,
    applyContractor: false,
    applySupplier: false,
    opening: null,
    closing: null,
    strokeColor: colors.primary500,
    strokeWidth: 2,
    fillColor: colors.primary600,
    schedule: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
    },
    isValidDetails: function () {
        return (
            this.name.trim() !== '' &&
            this.speedUnit !== null &&
            this.speedUnit !== '' &&
            this.speedLimit !== null &&
            this.speedLimit !== '' &&
            this.speedTolerance !== null &&
            this.speedTolerance !== '' &&
            (this.applyEmployee === true || this.applySupplier === true || this.applyContractor === true)
        );
    },
  isValidSchedule: function (dayArray) {
    if (!Array.isArray(dayArray) || dayArray.length === 0) return false;
    if (!this.opening || !this.closing) return false;


   return this.closing > this.opening;
},

    isValidArea: function (geofences) {
        return geofences.length > 0;
    },
    toRegister: function (coordinates, dayArray) {
        DAYS_MODEL.forEach((e) => {
            this.schedule[e.key] = dayArray.includes(e.value) ? 1 : 0;
        });
        let schedule = Object.entries(this.schedule)?.map(([key, value]) => value);
        schedule = schedule.join(' ');
        schedule = schedule + ' ' + getTimeFormatFromTime(this.opening) + '-' + getTimeFormatFromTime(this.closing);

        return {
            id: this.geofenceId,
            name: this.name,
            description: this.description || null,
            geofenceConfigDTO: {
                id: this.geofenceConfigId,
                geofenceId: this.geofenceId,
                strokeColor: this.strokeColor,
                fillColor: this.fillColor,
                strokeWidth: this.strokeWidth,
                schedule: schedule,
                applyEmployee: this.applyEmployee,
                applyContractor: this.applyContractor,
                applySupplier: this.applySupplier,
                speedLimit: this.speedLimit,
                speedTolerance: this.speedTolerance,
                speedUnit: this.speedUnit,
            },
            coordinates: coordinates.map(([latitude, longitude]) => {
                return {
                    latitude: latitude,
                    longitude: longitude,
                };
            }),
        };
    },
    toSet: function (data) {
        let schedule = this.toSetDays(data?.geofenceConfigDTO?.schedule);

        return {
            ...this,
            geofenceId: data.id,
            geofenceConfigId: data.geofenceConfigDTO.id,
            name: data.name,
            speedUnit: data.geofenceConfigDTO.speedUnit,
            speedLimit: data.geofenceConfigDTO.speedLimit,
            speedTolerance: data.geofenceConfigDTO.speedTolerance,
            description: data.description,
            applyEmployee: data.geofenceConfigDTO.applyEmployee,
            applyContractor: data.geofenceConfigDTO.applyContractor,
            applySupplier: data.geofenceConfigDTO.applySupplier,
            opening: getToTime(schedule.opening),
            closing: getToTime(schedule.closing),
            strokeColor: data.geofenceConfigDTO.strokeColor,
            strokeWidth: data.geofenceConfigDTO.strokeWidth,
            fillColor: data.geofenceConfigDTO.fillColor,
        };
    },
    toSetCoordinates: function (coordinates) {
        return coordinates.map((c) => {
            return [c.latitude, c.longitude];
        });
    },
    toSetDays: function (schedule) {
        const parts = schedule?.trim()?.split(' ') || [];
        const timeRange = parts.pop();
        const [opening, closing] = timeRange.split('-');
        const days = parts.map(Number);

        let aux = [];
        days.map((d, index) => {
            if (d) {
                let day = DAYS_MODEL.find((obj) => obj.value === index);
                aux.push(day.value);
            }
        });

        return {
            days: aux,
            opening,
            closing,
        };
    },
    toSetMap: function (e, setDayArray) {
        let schedule = GEOFENCES_MODEL.toSetDays(e?.geofenceConfigDTO?.schedule);
        if (setDayArray) setDayArray(schedule.days);
        let coordinates = this.toSetCoordinates(e.coordinates);

        return {
            ...e,
            ...e.geofenceConfigDTO,
            geofenceId: e.id,
            geofenceConfigId: e.geofenceConfigDTO.id,
            opening: schedule.opening,
            closing: schedule.closing,
            coordinates,
            type: coordinates.length === 4 ? DRAW_MODE.RECTANGLE : DRAW_MODE.POLYGON,
        };
    },
    buildGeofenceListMap: function (data, setDayArray) {
        return data.map((e) => {
            return this.toSetMap(e, setDayArray);
        });
    },
    getGeofenceCenter: function (geofence) {
        if (!geofence?.type || !geofence.coordinates) return [DEFAULT_LATITUDE, DEFAULT_LONGITUDE];

        if (geofence?.type === DRAW_MODE.RECTANGLE) {
            const polygon = L.polygon(geofence.coordinates);
            const latLong = polygon.getBounds().getCenter();
            return [latLong.lat, latLong.lng];
        }
        const rectangle = L.rectangle(geofence.coordinates);
        const latLong = rectangle.getBounds().getCenter();
        return [latLong.lat, latLong.lng];
    },
};

export const DRAW_MODE = {
    POLYGON: 'poligon',
    RECTANGLE: 'rectangle',
};

export const CREATE_STEP = {
    DETAILS: 0,
    ACTIVE_SCHEDULE: 1,
    DEFINE_AREA: 2,
    SUMMARY: 3,
};

/**
 * @description
 * Utility function that checks whether a specific media option
 * is currently active within the provided `mediaOptions` list.
 *
 * @param {Array} mediaOptions - Array of media option objects.
 * Each object should contain `mediaOptionId` and `statusId`.
 * @param {number|string} targetOptionId - The target media option ID to check.
 * @param {number|string} activeStatusId - The status value that represents an active media option.
 * @returns {boolean} Returns `true` if the target media option is active, otherwise `false`.
 *
 * @example
 * isMediaOptionChecked(item.mediaOptions, MEDIA_OPTIONS.EMAIL, STATUS_MODEL.ACTIVE_COMPANY)
 */
export const isMediaOptionChecked = (mediaOptions, targetOptionId, activeStatusId) => {
    if (!Array.isArray(mediaOptions)) return false;

    return mediaOptions.some((media) => media.mediaOptionId === targetOptionId && media.statusId === activeStatusId);
};

export const SPEED_UNIT_MODEL = {
    KM_H: {
        id: 1,
        name: 'KM/H',
    },
    MPH: {
        id: 2,
        name: 'MPH',
    },
};

export const getDrawLocalModel = (t) => ({
    draw: {
        toolbar: {
            actions: {
                title: t('cancel_draw_title'),
                text: t('cancel_draw_text'),
            },
            finish: {
                title: t('finish_draw_title'),
                text: t('finish_draw_text'),
            },
            undo: {
                title: t('undo_draw_title'),
                text: t('undo_draw_text'),
            },
            buttons: {
                polyline: t('draw_polyline'),
                polygon: t('draw_polygon'),
                rectangle: t('draw_rectangle'),
                circle: t('draw_circle'),
                marker: t('draw_marker'),
                circlemarker: t('draw_circle_marker'),
            },
        },
        handlers: {
            circle: {
                tooltip: { start: t('circle_tooltip_start') },
                radius: t('circle_radius'),
            },
            circlemarker: { tooltip: { start: t('circle_marker_tooltip_start') } },
            marker: { tooltip: { start: t('marker_tooltip_start') } },
            polygon: {
                tooltip: {
                    start: t('polygon_tooltip_start'),
                    cont: t('polygon_tooltip_cont'),
                    end: t('polygon_tooltip_end'),
                },
            },
            polyline: {
                error: t('polyline_error'),
                tooltip: {
                    start: t('polyline_tooltip_start'),
                    cont: t('polyline_tooltip_cont'),
                    end: t('polyline_tooltip_end'),
                },
            },
            rectangle: { tooltip: { start: t('rectangle_tooltip_start') } },
            simpleshape: { tooltip: { end: t('simple_shape_tooltip_end') } },
        },
    },
    edit: {
        toolbar: {
            actions: {
                save: { title: t('edit_save_title'), text: t('edit_save_text') },
                cancel: { title: t('edit_cancel_title'), text: t('edit_cancel_text') },
                clearAll: { title: t('edit_clear_all_title'), text: t('edit_clear_all_text') },
            },
            buttons: {
                edit: t('edit_button'),
                editDisabled: t('edit_button_disabled'),
                remove: t('remove_button'),
                removeDisabled: t('remove_button_disabled'),
            },
        },
        handlers: {
            edit: { tooltip: { text: t('edit_tooltip_text'), subtext: t('edit_tooltip_subtext') } },
            remove: { tooltip: { text: t('remove_tooltip_text') } },
        },
    },
});

//Checks if the closing time is before the opening time.
export const isCloseTimeNotValid = (opening, closing) => {
    const openingTime = getTimeFormatFromTime(opening);
    const closingTime = getTimeFormatFromTime(closing);
    if (!openingTime || !closingTime) return false;
    return closingTime < openingTime;
};

// Checks if opening and closing times are exactly the same
export const areTimesEqual = (opening, closing) => {
    if (opening == null || closing == null) return false;
    const openingTime = getTimeFormatFromTime(opening);
    const closingTime = getTimeFormatFromTime(closing);

    return openingTime !== null && closingTime !== null ? closingTime === openingTime : false;
};
